import { render, staticRenderFns } from "./record-list.vue?vue&type=template&id=72df2558&scoped=true&"
import script from "./record-list.vue?vue&type=script&lang=js&"
export * from "./record-list.vue?vue&type=script&lang=js&"
import style0 from "./record-list.vue?vue&type=style&index=0&id=72df2558&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df2558",
  null
  
)

export default component.exports